import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class VehicleModelSelectionCacheService {
    private readonly SEARCH_KEY = 'select-vehicle-model:search';
    private readonly SELECTED_MODEL_KEY = 'select-vehicle-model:selected-model';

    getSearch(): string {
        return localStorage.getItem(this.SEARCH_KEY) || '';
    }

    setSearch(search: string): void {
        localStorage.setItem(this.SEARCH_KEY, search);
    }

    getSelectedModel(): string {
        return localStorage.getItem(this.SELECTED_MODEL_KEY) || 'All Vehicles';
    }

    setSelectedModel(model: string): void {
        localStorage.setItem(this.SELECTED_MODEL_KEY, model);
    }

    clear(): void {
        localStorage.removeItem(this.SEARCH_KEY);
        localStorage.removeItem(this.SELECTED_MODEL_KEY);
    }
}
